import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  BASE_URL,
  BASE_URL_PBIX_DOWNLOAD_REPORT,
  OCP_APIM_SUBSCRIPTION_KEY,
} from "../constants/constant";
import { Service } from "../services/service";
import { savePdf } from "../helpers/helper";
import axios from "axios";

const service = new Service();

export const initialState = {
  allVfAdminReport: [],
  allPackageByOrganisationId: [],
  allPackage: [],
  loading: false,
  currentTrend: null,
  isPackageAdded: false,
  reportMaster: [],
  packageMaster: [],
  workspaceDetails: {},
  selectedReport: {},
  categoryMaster: [],
  exportReportData: {},
  exportLoading: false,
};

export const getAllPackageByOrganisationId = createAsyncThunk(
  "get-all-package-by-organisationid",
  async (obj) => {
    const url = `${BASE_URL}/api/Package/GetPackageDetailsByOrganizaiton?organiziaitonId=${obj?.orgId}`;
    const params = { searchText: obj?.searchText, category: obj?.category };
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testPostApi(url, params, user_token);
    const data = response.data;
    return data;
  }
);

export const getAllPackage = createAsyncThunk(
  "get-all-package",
  async (obj) => {
    const url = `${BASE_URL}/api/Package/GetAllPackages`;
    const params = obj;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testPostApi(url, params, user_token);
    const data = response.data;
    return data;
  }
);

export const downloadReport = createAsyncThunk(
  "download-report",
  async (obj) => {
    // const url = `${BASE_URL_PBIX_DOWNLOAD_REPORT}&groupId=${obj?.groupId}&reportId=${obj?.reportId}&profileId=${obj?.profileId}`;
    const url = `${BASE_URL}/api/Report/ExportToFile`;
    // const params = {
    //   profileId: obj?.profileId,
    //   groupId: obj?.groupId,
    //   reportId: obj?.reportId,
    // };
    const user_token = localStorage.getItem("bb_access_token");
    const body = {
      profileId: obj?.profileId,
      groupId: obj?.groupId,
      reportId: obj?.reportId,

      // NEW — include filter objects from UI
      pageFilters: obj?.filter?.pageFilters || [],
      reportFilters: obj?.filters?.reportFilters || [],
      slicers: obj?.filters?.slicers || []
    };
    const response = await axios.post(url, body, {
      responseType: "arraybuffer",
      headers: {
        "Ocp-Apim-Subscription-Key": OCP_APIM_SUBSCRIPTION_KEY,
        Authorization: "Bearer  " + user_token,
      },
    });
    const data = response?.data;
    console.log("fetching", data);
    if (data) {
      savePdf(data, obj?.reportTitle);
    }
    return data;
  }
);

export const getAllVfAdminReport = createAsyncThunk(
  "get-all-vfadmin-report",
  async (obj) => {
    const url = `${BASE_URL}/api/Report/GetAllReports`;
    const params = obj;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testPostApi(url, params, user_token);
    const data = response.data;
    return data;
  }
);

export const getReportMaster = createAsyncThunk(
  "get-report-master",
  async () => {
    const url = `${BASE_URL}/api/Report/ReportMaster`;
    // const params = obj;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, {}, user_token);
    const data = response.data;
    return data;
  }
);

export const getCategoryMaster = createAsyncThunk(
  "get-category-master",
  async () => {
    const url = `${BASE_URL}/api/Report/ReportCategoryMaster`;
    // const params = obj;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, {}, user_token);
    const data = response.data;
    return data;
  }
);

export const getReportMasterById = createAsyncThunk(
  "get-report-master",
  async (obj) => {
    const url = `${BASE_URL}/api/Report/ReportMaster`;
    const params = obj;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, params, user_token);
    const data = response.data;
    return data;
  }
);

export const getWorkspaceDetailsById = createAsyncThunk(
  "get-workspace-details",
  async (obj) => {
    const url = `${BASE_URL}/api/Environment/GetWorkspaceDetailsByOrganization`;
    const params = { id: obj.organizationId };
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, params, user_token);
    const data = response.data;
    return data;
  }
);

export const getPackageMaster = createAsyncThunk(
  "get-package-master",
  async () => {
    const url = `${BASE_URL}/api/Package/PackageMaster`;
    // const params = obj;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, {}, user_token);
    const data = response.data;
    return data;
  }
);

export const createPackage = createAsyncThunk(
  "create-package",
  async ({ data }) => {
    let url = `/api/Organization/AddOrganization`;
    data = JSON.stringify(data);
    const user_token = localStorage.getItem("bb_access_token");
    let response = await service.newPostApi(url, data, user_token);
    return response;
  }
);

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    updateCurrentTrend(state, action) {
      state.currentTrend = action.payload;
    },
    updateSelectedReport(state, action) {
      state.selectedReport = action.payload;
    },
  },
  extraReducers: {
    [getAllPackageByOrganisationId.pending]: (state) => {
      state.loading = true;
    },
    [getAllPackageByOrganisationId.fulfilled]: (state, { payload }) => {
      state.allPackageByOrganisationId = payload;
      state.loading = false;
    },
    [getAllPackageByOrganisationId.rejected]: (state) => {
      state.allPackageByOrganisationId = [];
      state.loading = false;
    },
    [getAllPackage.pending]: (state) => {
      state.loading = true;
    },
    [getAllPackage.fulfilled]: (state, { payload }) => {
      state.allPackage = payload;
      state.loading = false;
    },
    [getAllPackage.rejected]: (state) => {
      state.allPackage = [];
      state.loading = false;
    },
    [downloadReport.pending]: (state) => {
      state.exportLoading = true;
    },
    [downloadReport.fulfilled]: (state, { payload }) => {
      state.exportReportData = payload;
      state.exportLoading = false;
    },
    [downloadReport.rejected]: (state) => {
      state.exportReportData = {};
      state.exportLoading = false;
    },
    [getAllVfAdminReport.pending]: (state) => {
      state.loading = true;
    },
    [getAllVfAdminReport.fulfilled]: (state, { payload }) => {
      state.allVfAdminReport = payload;
      state.loading = false;
    },
    [getAllVfAdminReport.rejected]: (state) => {
      state.allVfAdminReport = [];
      state.loading = false;
    },
    [getReportMaster.pending]: (state) => {
      state.loading = true;
    },
    [getReportMaster.fulfilled]: (state, { payload }) => {
      state.reportMaster = payload;
      state.loading = false;
    },
    [getReportMaster.rejected]: (state) => {
      state.reportMaster = [];
      state.loading = false;
    },
    [getCategoryMaster.pending]: (state) => {
      state.loading = true;
    },
    [getCategoryMaster.fulfilled]: (state, { payload }) => {
      state.categoryMaster = payload;
      state.loading = false;
    },
    [getCategoryMaster.rejected]: (state) => {
      state.categoryMaster = [];
      state.loading = false;
    },
    [getReportMasterById.pending]: (state) => {
      state.loading = true;
    },
    [getReportMasterById.fulfilled]: (state, { payload }) => {
      state.reportMaster = payload;
      state.loading = false;
    },
    [getReportMasterById.rejected]: (state) => {
      state.reportMaster = [];
      state.loading = false;
    },
    [getWorkspaceDetailsById.pending]: (state) => {
      state.loading = true;
    },
    [getWorkspaceDetailsById.fulfilled]: (state, { payload }) => {
      state.workspaceDetails = payload;
      state.loading = false;
    },
    [getWorkspaceDetailsById.rejected]: (state) => {
      state.workspaceDetails = {};
      state.loading = false;
    },
    [getPackageMaster.pending]: (state) => {
      state.loading = true;
    },
    [getPackageMaster.fulfilled]: (state, { payload }) => {
      state.packageMaster = payload;
      state.loading = false;
    },
    [getPackageMaster.rejected]: (state) => {
      state.packageMaster = [];
      state.loading = false;
    },
    [createPackage.pending]: (state, action) => {
      state.loading = true;
    },
    [createPackage.fulfilled]: (state, { payload }) => {
      state.status = payload.response.status;
      state.loading = false;
      state.isPackageAdded = true;
    },
    [createPackage.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});

export const { updateCurrentTrend, updateSelectedReport } =
  packageSlice.actions;
export default packageSlice.reducer;
